import React, { Component } from "react";
import { Div, Text, Button, Image } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class BuzzScaling extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div
            d="flex"
            flexDir={{ xs: "column-reverse", md: "row" }}
            className="solutions"
          >
            <Div
              flexGrow="1 1 48%"
              m="auto"
              p={{ r: { xs: "0", md: "3.25rem" } }}
            >
              <Div
                p={{ x: { xs: "1.5rem", md: "0" } }}
                textAlign={{ xs: "center", md: "left" }}
              >
                <Text
                  textSize="title2"
                  textWeight="bold"
                  className="main-text"
                  tag="h2"
                >
                  {content.heading}
                </Text>
                <Text
                  m={{ b: "1.6rem", t: ".5rem" }}
                  textSize={{ xs: "15px", md: "paragraph" }}
                  className="sub-text"
                  textColor="#D9D9D9"
                >
                  {content.text}
                </Text>
                <AnimateLink to={content.buttonLink}>
                  <Button
                    d="inline"
                    fontFamily="secondary"
                    h="3.125rem"
                    bg="primary"
                    hoverBg="#FFCB6F"
                    rounded="xs"
                    textWeight="800"
                    textColor="black"
                    w={{ xs: "100%", md: "auto" }}
                  >
                    {content.button}
                  </Button>
                </AnimateLink>
              </Div>
            </Div>
            <Div flexGrow="1 1 50%" m={{ md: "auto" }}>
              <ImageLink link={content.imgLink}>
                <Div
                  bgImg={content.image}
                  m={{ b: { xs: "2rem", md: "auto" } }}
                  p={{ b: "85%" }}
                  bgSize="contain"
                  bgRepeat="no-repeat"
                  bgPos="center"
                ></Div>
              </ImageLink>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
